import { Disclosure } from '@headlessui/react';
import { Fragment, useState } from 'react';
import { Button } from '../../../../core/components/atoms/Button';
import { Icon } from '../../../../core/components/atoms/Icon';
import { Typography } from '../../../../core/components/molecules/Typography';
import { Modal } from '../../../../core/components/templates/Modal';
import { DISCIPLINES } from '../../../../core/utils/new_discipline';
import InnerCheckbox from '../../../Disciplines/components/exercises/components/innerCheckbox';
import { favoriteFilterStore } from '../../stores/favoriteFilterStore';
import './styles.css';

interface IModalFilter {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

export default function FilterTheme({
  isOpen,
  onClose,
  onSubmit,
}: IModalFilter) {
  const {
    category,
    discipline,
    setCategory,
    setDiscipline,
    addCategory,
    addDiscipline,
    removeCategory,
    removeDiscipline,
    resetFilter,
  } = favoriteFilterStore();

  const [isClean, setIsClean] = useState<boolean>(false);
  const [categoryAux, setCategoryAux] = useState<string[]>([]);
  const [disciplineAux, setDisciplineAux] = useState<string[]>([]);

  const disciplines = DISCIPLINES.filter((discipline) => !discipline.disabled).map((discipline) => {
    return {
      slug: discipline.slug,
      name: discipline.name.replace('Humana', ''),
    };
  });

  const handleCategory = (categoria: string) => {
    if (isClean) {
      setIsClean(false);
    }

    const aux = [...category];

    if (aux.includes(categoria)) {
      removeCategory(categoria);
    } else {
      addCategory(categoria);
    }
  };

  const handleDiscipline = (disciplina: string) => {
    if (isClean) {
      setIsClean(false);
    }

    const aux = [...discipline];

    if (aux.includes(disciplina)) {
      removeDiscipline(disciplina);
    } else {
      addDiscipline(disciplina);
    }
  };

  const reset = () => {
    setIsClean(true);
    setCategoryAux(category);
    setDisciplineAux(discipline);
    resetFilter();
  };

  const handleSubmit = () => {
    if (isClean) {
      setIsClean(false);
      resetFilter();
      onSubmit();
    } else {
      setCategoryAux([]);
      setDisciplineAux([]);

      onSubmit();
    }
  };

  const abbandon = () => {
    if (isClean) {
      setCategory(categoryAux);
      setDiscipline(disciplineAux);
      setIsClean(false);
    }

    onClose();
  };

  return (
    <Modal
      position={window.innerWidth < 768 ? 'bottom' : 'top-right'}
      size='md'
      isOpen={isOpen}
      onClose={() => abbandon()}
      className='xs:h-[90vh] xs:w-full sm:h-[75vh] md:h-[95vh] md:w-[35%]'
      title='Filtrar temas'
    >
      <div
        id='filterContainer'
        className='flex w-full flex-col gap-md overflow-x-auto px-2 py-2 xs:h-[58vh] sm:h-[48vh] md:h-[75vh]'
      >
        <Disclosure>
          {({ open }) => (
            <Fragment>
              <Disclosure.Button className='flex w-full justify-between text-left'>
                <Typography size='h4' type='title' className='text-left'>
                  Tipo de conteúdo
                </Typography>
                <Icon
                  Icon='expand_more'
                  type='material'
                  className={`${open ? 'rotate-180 transform' : ''} h-5 w-5 text-mono-color-black`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className='mt-5 flex w-full flex-col gap-xl pb-3 pl-4'>
                <InnerCheckbox
                  onChange={() => handleCategory('lesson')}
                  label='Videoaulas'
                  checked={category.indexOf('lesson') >= 0}
                  id='category-lesson'
                  value='lesson'
                />
                <InnerCheckbox
                  onChange={() => handleCategory('exercise')}
                  label='Exercícios'
                  checked={category.indexOf('exercise') >= 0}
                  id='category-exercise'
                  value='exercise'
                />
                <InnerCheckbox
                  onChange={() => {
                    handleCategory('apostila');
                    handleCategory('mapamental');
                  }}
                  label='Materiais'
                  checked={
                    category.indexOf('apostila') >= 0 ||
                    category.indexOf('mapamental') >= 0
                  }
                  id='category-material'
                  value='material'
                />
                <InnerCheckbox
                  onChange={() => handleCategory('audio')}
                  label='Podcasts'
                  checked={category.indexOf('audio') >= 0}
                  id='category-audio'
                  value='audio'
                />
                <InnerCheckbox
                  onChange={() => handleCategory('live')}
                  label='Lives'
                  checked={category.indexOf('live') >= 0}
                  id='category-live'
                  value='live'
                />
              </Disclosure.Panel>
            </Fragment>
          )}
        </Disclosure>
        <div className='w-full border-b-hairline border-mono-color-light' />
        <Disclosure>
          {({ open }) => (
            <Fragment>
              <Disclosure.Button className='flex w-full justify-between text-left'>
                <Typography size='h4' type='title' className='text-left'>
                  Disciplinas
                </Typography>
                <Icon
                  Icon='expand_more'
                  type='material'
                  className={`${open ? 'rotate-180 transform' : ''} h-5 w-5 text-mono-color-black`}
                />
              </Disclosure.Button>
              <Disclosure.Panel className='mt-5 flex w-full flex-col gap-xl pb-3 pl-4'>
                {disciplines.map((item) => (
                  <InnerCheckbox
                    key={item.slug}
                    onChange={() => handleDiscipline(item.slug)}
                    label={item.name}
                    checked={discipline.indexOf(item.slug) >= 0}
                    id={`category-${item.slug}`}
                    value={item.slug}
                  />
                ))}
              </Disclosure.Panel>
            </Fragment>
          )}
        </Disclosure>
        <div className='w-full border-b-hairline border-mono-color-light' />
      </div>
      <div className='fixed bottom-0 left-0 flex w-full flex-row items-center justify-center gap-lg px-4 py-5'>
        <Button
          variant='text'
          className='w-1/2 xs:text-sm md:text-md'
          full
          onClick={() => reset()}
        >
          <Icon Icon='delete' type='material' className='text-sm' />
          Limpar seleção
        </Button>
        <Button
          className='w-1/2 xs:text-sm md:text-md'
          full
          onClick={() => handleSubmit()}
        >
          Aplicar filtros
        </Button>
      </div>
    </Modal>
  );
}
